import React from 'react';
import PropTypes from 'prop-types';

import { SearchStatsGlobal } from '@search';
import { SortByDropdown } from '@search/SortByDropdown';
import ViewToggleButtons from '../../elements/ViewToggleButtons';

import { useViewTypeContext } from '@context/viewTypeContext';
import { useAttendeeMode } from '@context/attendeeModeContext';
import useAttendeePdfs from '@hooks/useAttendeePdfs';
import AttendeePdfLink from '../../../../../attendee-pdf-access/js/components/AttendeePdfLink';

const SearchOptionsDesktop = ({ displayMap = false, onSortByChange, onViewTypeChange, showCalendar }) => {
    const { eventCode } = useAttendeeMode() ?? {};
    const { pdfGroups } = useAttendeePdfs(eventCode);

    const [viewType, setViewType] = useViewTypeContext();
    const isCalendarView = viewType === 'calendar';

    const handleViewChange = view => {
        setViewType(view);
        onViewTypeChange?.(view);
    };

    return (
        <ul className="nav nav-pills listing-filters d-flex justify-content-start">
            <li className="align-self-center mr-auto">
                <SearchStatsGlobal />
            </li>

            {pdfGroups.length > 0 && (
                <li className="align-self-center mr-md-5 mt-0.25rem">
                    <AttendeePdfLink pdfGroups={pdfGroups} eventCode={eventCode} className="text-sm accent" id="attendee-pdf-download" />
                </li>
            )}

            {!isCalendarView && (
                <li className="nav-item dropdown d-inline-block my-md-auto mr-md-5 align-self-center">
                    <SortByDropdown onSortByChange={onSortByChange} />
                </li>
            )}

            <ViewToggleButtons
                displayMap={displayMap}
                onViewTypeChange={handleViewChange}
                showCalendar={showCalendar}
            />
        </ul>
    );
};

SearchOptionsDesktop.propTypes = {
    displayMap: PropTypes.bool,
    onSortByChange: PropTypes.func.isRequired,
    onViewTypeChange: PropTypes.func.isRequired,
    showCalendar: PropTypes.bool,
};

export default SearchOptionsDesktop;
